export const CHARACTER_MODEL_URL = "/models/michelle.de72fe5d.glb";

let preloadRequest = null;

export function preloadCharacterModel() {
  if (!preloadRequest) {
    preloadRequest = fetch(CHARACTER_MODEL_URL, { cache: "force-cache" })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Failed to preload character model: ${response.status}`);
        }

        await response.arrayBuffer();
      })
      .catch(() => {
        preloadRequest = null;
      });
  }

  return preloadRequest;
}
